export default {
    modalQuickActionVariations: {
        title: 'AI',
        generateWithAi: 'Generate with AI',
        improveWriting: 'Improve writing',
        fixSpelling: 'Fix spelling and grammar',
        simplifyWriting: 'Simplify writing',
        makeLonger: 'Make longer',
        makeShorter: 'Make shorter',
        replaceText: 'Replace Text',
        addBelow: 'Add Below',
        cancel: 'Cancel',
        selectQuickActionTitle: 'Tell AI what to do next..',
        regenerate: 'Regenerate',
    },
};
